import { CollapsibleCard } from "../CollapsibleCard";

interface HandlingOperationsSectionProps {
  submission: any;
  defaultOpen?: boolean;
}

export const HandlingOperationsSection = ({
  submission,
  defaultOpen = false,
}: HandlingOperationsSectionProps) => {
  return (
    <CollapsibleCard title="5. Handling & Operations" defaultOpen={defaultOpen}>
      <div className="space-y-3 md:space-y-4">
        <div className="grid grid-cols-1 gap-3 md:grid-cols-2 md:gap-4">
          <div className="flex justify-between md:flex-col md:justify-start md:space-y-1">
            <span className="text-sm font-medium text-muted-foreground">
              Storage Method
            </span>
            <span className="text-sm font-medium">
              {submission.storageMethod}
            </span>
          </div>
          <div className="flex justify-between md:flex-col md:justify-start md:space-y-1">
            <span className="text-sm font-medium text-muted-foreground">
              Idle Pallet Storage
            </span>
            <span className="text-sm font-medium">
              {submission.hasIdlePalletStorage ? "Yes" : "No"}
            </span>
          </div>
          {submission.hasIdlePalletStorage && (
            <div className="flex justify-between md:flex-col md:justify-start md:space-y-1">
              <span className="text-sm font-medium text-muted-foreground">
                Pallet Material
              </span>
              <span className="text-sm font-medium">
                {submission.idlePalletMaterial}
              </span>
            </div>
          )}
        </div>
      </div>
    </CollapsibleCard>
  );
};
